/**
 * La règle du serveur (`app/core/phone.py`), rejouée ici pour répondre avant
 * l'envoi : un indicatif « + », des chiffres et quelques séparateurs, de 8 à
 * 15 chiffres. Un numéro local ouvrirait, depuis WhatsApp, une conversation
 * avec un inconnu.
 *
 * Partagée par le tunnel d'achat et « Personnaliser cette table » : les deux
 * formulaires doivent refuser exactement les mêmes numéros.
 */
export function isInternationalNumber(value: string): boolean {
  const cleaned = value.trim()
  const digits = cleaned.replace(/\D/g, '').length
  return /^\+[0-9 ().-]*$/.test(cleaned) && digits >= 8 && digits <= 15
}

/** La même vérification d'adresse que le tunnel : de quoi éviter une faute de frappe. */
export function looksLikeEmail(value: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim())
}
